export const EXPORT_TYPE = {
  ALL: 'EXPORT_ALL',
  SELECTED: 'EXPORT_SELECTED',
} as const;

export const DIALOGUE_TYPE = {
  CHOOSE_EXPORT: 'CHOOSE_EXPORT_DIALOGUE',
  EXPORT_IN_PROGRESS: 'EXPORT_IN_PROGRESS_DIALOGUE',
} as const;

export type ExportType = (typeof EXPORT_TYPE)[keyof typeof EXPORT_TYPE];
export type DialogueType = (typeof DIALOGUE_TYPE)[keyof typeof DIALOGUE_TYPE];
